// extracted by mini-css-extract-plugin
export default {"container":"k3PjQTgC","panel":"ZX_ET6v1","emptyList":"y3OrMGkQ","text":"W7PJUQAi","header":"vhx2gdHr","description":"iQxbUd1C"};